import React from 'react';
import StudentCommentary from './StudentCommentary';
import SefariaCommentary from './SefariaCommentary';
import './CommentaryComponent.css';

const CommentaryComponent = ({ commentaryData, addComment, sourceText, selectedVerse }) => {
  return (
    <div className="commentary-container">
      <StudentCommentary
        commentaryData={commentaryData}
        addComment={addComment}
      />
      <SefariaCommentary
        sourceText={sourceText}
        selectedVerse={selectedVerse}
      />
    </div>
  );
};

export default CommentaryComponent;
